module.exports = {
	"author": "DigixGlobal",
	"title": "Some useful constants",
	"fileName": "contracts/Constants.sol",
	"name": "Constants",
	"abi": [],
	"bin": "6060604052346000575b60358060166000396000f30060606040525b60005600a165627a7a72305820f119f87deefba5bc0574c551eb94f29f4b31ec423f35a582413f0767ece88f1a0029",
	"opcodes": "PUSH1 0x60 PUSH1 0x40 MSTORE CALLVALUE PUSH1 0x0 JUMPI JUMPDEST PUSH1 0x35 DUP1 PUSH1 0x16 PUSH1 0x0 CODECOPY PUSH1 0x0 RETURN STOP PUSH1 0x60 PUSH1 0x40 MSTORE JUMPDEST PUSH1 0x0 JUMP STOP LOG1 PUSH6 0x627A7A723058 SHA3 CALL NOT 0xf8 PUSH30 0xEEFBA5BC0574C551EB94F29F4B31EC423F35A582413F0767ECE88F1A0029 ",
	"source": "pragma solidity ^0.4.6;\n\n/// @title Some useful constants\n/// @author DigixGlobal\n\ncontract Constants {\n\n    address constant NULL_ADDRESS = 0x0;\n    uint256 constant NONE = uint256(0);\n    bytes32 constant EMPTY = 0x0;\n}\n",
	"abiDocs": []
};


//////////////////
// WEBPACK FOOTER
// ./docs/Constants.json
// module id = 1073
// module chunks = 0